// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"4446f6e7","33":"a8c5388c","222":"771f9d79","237":"9c853ba2","524":"cbb549ea","983":"8f17cba2"}[chunkId] + ".chunk.js";
};